import React from "react";
import {DateOperationConfiguration} from "./configuration/date-operation-configuration";
import {PreviewTab} from "../preview-tab/preview-tab";

export const DateOperationStepPanelTabs = {
    configuration: DateOperationConfiguration,
    preview: PreviewTab,
};
